import { _ } from '../../lib';
export const stubTextarea = document.createElement('textarea');
export const stubDiv = document.createElement('div');
export const stubForm = document.createElement('form');
export const stubSelect = document.createElement('select');
export const stubInput = document.createElement('input');
export const stubButton = document.createElement('button');
export const stubImage = document.createElement('img');
export const stubModal = { getElement: () => stubDiv };
export const stubListInstance = {
    focus: _.noop,
    blur: _.noop,
    selectAll: _.noop,
    selectNone: _.noop,
    setSelected: _.noop,
    moveSelection: _.noop,
    updateScrollPosition: _.noop,
    refreshScrollJack: _.noop,
    rs: null,
    renderedRows: [],
    getKeyDownEventDelta: () => [],
    forwardEventScroll: _.noop,
    forwardEventMouseDown: _.noop,
    forwardEventMouseClick: _.noop,
    forwardEventKeyDown: _.noop,
    noop: _.noop,
    getElement: () => stubDiv,
    getRowValues: () => [],
};
export const stubListGrid = {
    getElement: () => stubDiv,
    getListElement: () => stubDiv,
    getFullTable: () => [],
    getFilteredRecords: () => [],
    getHiddenFields: () => [],
    getList: () => stubListInstance,
    focus: () => void 0,
};
export const stubFocusable = (el) => ({
    focus: _.noop,
    select: _.noop,
    getElement: () => el,
});
export const stubResizeSplitterInstance = {
    getElement: () => stubDiv,
    reset: () => { },
};
export const stubTreeListInstance = {
    focus: _.noop,
    select: _.noop,
    getElement: () => stubDiv,
    getList: () => stubListGrid,
};
export const stubCanvas = document.createElement('canvas');
export const stubEditableGridInstance = {
    getElement: () => stubDiv,
    listGrid: () => stubListGrid,
    getDefaultDataState: () => ({}),
    getChangeDelta: () => ({
        appended: [],
        appendedIDs: [],
        data: [],
        deleted: [],
        isChanged: false,
        updated: {},
    }),
    isChanged: () => false,
    reset: () => { },
    save: async () => Promise.resolve(),
    focusNewRow: () => { },
    recordCount: { filtered: 0, total: 0 },
};
//# sourceMappingURL=stubs.js.map